import Headroom from 'headroom.js';

export const init = (element) => {
  const headroom  = new Headroom(element, {
    tolerance: {
      down: 10,
      up: 20,
    },
    offset: 15,
  });

  headroom.init();
};

export default init;
